import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'contract_not_found.title',
  },
  subTitle: {
    id: 'contract_not_found.sub_title',
  },
  nextLabel: {
    id: 'auth_by_contract_failed.next_label',
  },
  previousLabel: {
    id: `auth_by_contract_failed.previous_label`,
  },
  agentLocation: {
    id: `auth_by_contract_failed.agent_location`,
  },
  helpMessage: {
    id: `auth_by_contract_failed.help_message`,
  },
});
